(function () {
    'use strict';

    run.parts.hideShowPassword = function () {

        jQuery(document).ready(function($) {
            var _field = null;

            $('input[name="password"]').hideShowPassword(false, true);

            $('input[name="password"]').password({
                shortPass: translations.passwordMeter.short,
                badPass: translations.passwordMeter.bad,
                goodPass: translations.passwordMeter.good,
                strongPass: translations.passwordMeter.strong,
                containsUsername: translations.passwordMeter.username,
                enterPass: translations.passwordMeter.type,
                showPercent: false,
                showText: true, // shows the text tips
                animate: true, // whether or not to animate the progress bar on input blur/focus
                animateSpeed: 'fast', // the above animation speed
                username: false, // select the username field (selector or jQuery instance) for better password checks
                usernamePartialMatch: true, // whether to check for username partials
                minimumLength: 6 // minimum password length (below this threshold, the score is 0)
            }).on('passwordShown', function() {
                _field = $(this);
                // console.log('password shown');
            }).on('passwordHidden', function() {
                _field = null;
                // console.log('password hidden');
            });

            $('.hideShowPassword-toggle').on('click', function(e) {
                var _input_password = $(this).parent('.hideShowPassword-wrapper').find('input[name="password"]');
                $(_input_password).focus();
            });

            $('input[name="password"]').on('focus blur click hover', function(e) {
                $(this).removeAttr('readonly');
            });

            $('form').submit(function(event) {
                event.preventDefault();
                if (_field) {
                    $(_field).togglePassword();
                }

                $(this).unbind('submit').submit();
            });
        });

    };
})();